window.site = (window.site || {});

/**
 * Init AjaxPagination related scripts
 * @class Site
 * @static
 */
site.AjaxForms = (function AjaxForms() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const isFormValid = ($form) => {
      let hasErrors = false;
      const $inputNameContainer = $form.querySelector('[data-input-name]');
      const $inputEmailContainer = $form.querySelector('[data-input-email]');
      const $inputMessageContainer = $form.querySelector('[data-input-message]');
      const $inputAction = $form.querySelector('input[name="action"]');

      // Disable all errors
      const $errors = $form.querySelectorAll('.input-error');
      if ($errors.length) {
        $errors.forEach($error => {
          $error.classList.remove('is-active');
        });
      }

      // Check action url
      if (!$inputAction) {
        hasErrors = true;
      }

      // Check Name
      if ($inputNameContainer) {
        const $inputName = $inputNameContainer.querySelector('input');
        const nameValue = $inputName.value;

        if (!nameValue.length) {
          hasErrors = true;

          const $error = $inputNameContainer.querySelector('.input-error');
          const error = site.App.config('locale') === 'fr' ? 'Veuillez entrer votre nom.' : 'Please enter your name';
          $error.textContent = error;
          $error.classList.add('is-active');
        }
      }

      // Check Email
      if ($inputEmailContainer) {
        const $inputEmail = $inputEmailContainer.querySelector('input');
        const emailValue = $inputEmail.value;

        if (!emailValue.length) {
          hasErrors = true;

          const $error = $inputEmailContainer.querySelector('.input-error');
          const error = site.App.config('locale') === 'fr' ? 'Veuillez entrer votre courriel.' : 'Please enter your email';
          $error.textContent = error;
          $error.classList.add('is-active');
        }
      }

      // Check Message
      if ($inputMessageContainer) {
        const $inputMessage = $inputMessageContainer.querySelector('textarea');
        const messageValue = $inputMessage.value;

        if (!messageValue.length) {
          hasErrors = true;

          const $error = $inputMessageContainer.querySelector('.input-error');
          const error = site.App.config('locale') === 'fr' ? 'Veuillez entrer un message.' : 'Please enter a message';
          $error.textContent = error;
          $error.classList.add('is-active');
        }
      }

      return !hasErrors;
    };

    ////////////////////////////////// FORM CONTACT CLassique //////////////////////////////////////////////////////

    const formClassique = document.querySelector('#contact-form-classique');

    if (formClassique) {
      formClassique.addEventListener('submit', function (ev) {
        // Prevent the form from actually submitting
        ev.preventDefault();

        if (isFormValid(formClassique)) {
          const formData = new FormData();
          for (let i = 0; i < formClassique.length; ++i) {
            if (formClassique[i].type === 'checkbox') {
              if (formClassique[i].checked) {
                formData.append(formClassique[i].name, formClassique[i].value);
              }
            } else {
              formData.append(formClassique[i].name, formClassique[i].value);
            }
          }

          const actionUrl = formClassique.querySelector('input[name="action"]');

          axios({
            url: actionUrl.value,
            method: 'POST',
            data: formData
          })
            .then((res) => {
              return res.data;
            })
            .then((data) => {
              formClassique.classList.add('is-active');
              document.querySelector('.thank-you-classique').classList.add('is-active');

              setTimeout(function(){
                formClassique.reset();
                document.querySelector('.contact-form-cta').classList.remove('is-active');
                document.querySelector('.classique-form-texts').classList.add('is-active');
                document.querySelector('.thank-you-classique').classList.remove('is-active');
              }, 4500);
            })
            .catch(function (error) {
              console.log('error :: ', error);
            });
        }
      });
    }

    ////////////////////////////////// FORM CONTACT //////////////////////////////////////////////////////

    const form = document.querySelector('#contact-form');

    if (form) {
      form.addEventListener('submit', function (ev) {
        // Prevent the form from actually submitting
        ev.preventDefault();
        if (isFormValid(form)) {
          const formData = new FormData();
          for (let i = 0; i < form.length; ++i) {
            if (form[i].type === 'checkbox') {
              if (form[i].checked) {
                formData.append(form[i].name, form[i].value);
              }
            } else {
              formData.append(form[i].name, form[i].value);
            }
          }

          axios({
            url: form.getAttribute('action'),
            method: 'POST',
            data: formData
          })
            .then((res) => {
              return res.data;
            })
            .then((data) => {
              form.classList.add('is-active');
              document.querySelector('.thank-you').classList.add('is-active');

              setTimeout(function(){
                document.querySelector('.contact-form').classList.remove('is-active');
                document.querySelector('.contact-form-overlay').classList.remove('is-active');
                form.classList.remove('is-active');
                document.querySelector('.thank-you').classList.remove('is-active');
              }, 4500);
            })
            .catch(function (error) {
              console.log('error :: ', error);
            });
        }
      });
    }

    ////////////////////////////////// FORM PARTNER //////////////////////////////////////////////////////

    const formPartner = document.querySelector('#partner-form');
    const blockBecome = document.querySelector('.block-become');

    if (formPartner) {
      formPartner.addEventListener('submit', function (ev) {
        // Prevent the form from actually submitting
        ev.preventDefault();

        const formData = new FormData();
        console.log({formPartner});

        for (let i = 0; i < formPartner.length; ++i) {
          if (formPartner[i].type === 'checkbox') {
            if (formPartner[i].checked) {
              formData.append(formPartner[i].name, formPartner[i].value);
            }
          } else {
            formData.append(formPartner[i].name, formPartner[i].value);
          }
        }


        console.log(formData);

        axios({
          url: form.getAttribute('action'),
          method: 'POST',
          data: formData
        })
          .then((res) => {
            console.log('res partner :: ', {res});
            return res.data;
          })
          .then((data) => {
            console.log('data partner :: ', data);
            formPartner.classList.remove('is-active');
            blockBecome.querySelector('.form-wrapper').classList.add('is-active');
            blockBecome.querySelector('.thank-you-partner').classList.add('is-active');
          })
          .catch(function (error) {
            console.log('error :: ', error);
          });
      });
    }

    ////////////////////////////////// FORM APPLICATION //////////////////////////////////////////////////////

    const formApplication = document.querySelector('#spontaneous-form');
    const blockSpontaneous = document.querySelector('.spontaneous-wrapper');

    if (formApplication) {
      formApplication.addEventListener('submit', function (ev) {
        // Prevent the form from actually submitting
        ev.preventDefault();

        const formData = new FormData();
        console.log({formApplication});

        for (let i = 0; i < formApplication.length; ++i) {
          if (formApplication[i].type === 'checkbox') {
            if (formApplication[i].checked) {
              formData.append(formApplication[i].name, formApplication[i].value);
            }
          } else {
            formData.append(formApplication[i].name, formApplication[i].value);
          }
        }


        console.log(formData);

        axios({
          url: form.getAttribute('action'),
          method: 'POST',
          data: formData,
          headers: {'Content-Type': 'multipart/form-data'}
        })
          .then((res) => {
            console.log('res Spontaneous :: ', {res});
            return res.data;
          })
          .then((data) => {
            console.log('data Spontaneous :: ', data);
            formApplication.classList.remove('is-active');
            blockSpontaneous.querySelector('.form-wrapper').classList.add('is-active');
            blockSpontaneous.querySelector('.thank-you-partner').classList.add('is-active');
          })
          .catch(function (error) {
            console.log('error :: ', error);
          });
      });
    }

    return true;
  };


  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
